module.exports = __webpack_public_path__ + "img/food_03.901063e9.jpg";